import type { ReactNode } from 'react';

import type { MacroAttributes } from '@atlaskit/editor-common/provider-factory';

import { createMetadataLoader } from '../extensions-common/macro-loaders';
import type { MacroName } from '../extensionConstants';

import { isAllowedWithFeatureFlags } from './blocklist';
import { autoConvert } from './converters/auto-convert';

export type MacroMetadata = {
	macroName: MacroName;
	title: string;
	[key: string]: any;
	description?: string;
};

export type MacroConfig = {
	contentId: string | undefined;
	setActiveModal?: (component: ReactNode, props: any) => void;
	closeActiveModal?: () => void;
};

const loadMacroMetadata = createMetadataLoader();

export function getAutoConverter(
	browserConfig: MacroConfig,
): Promise<(link: string) => MacroAttributes | null> {
	return autoConvert(getMacroMetaData, browserConfig);
}

export const getMacroMetaData = async (): Promise<MacroMetadata[]> => {
	const macros = await loadMacroMetadata();
	const isAllowed = isAllowedWithFeatureFlags();

	return macros.filter((macroMetadata) => {
		if (macroMetadata.hidden) {
			return false;
		}

		return isAllowed(macroMetadata);
	});
};
